export class CountryModel {
    constructor(public id: number, public countryName: string, public countryCode: string) {
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/country.model.ts